import { Alert, Box, styled } from "@mui/material";

export const Container = styled(Box)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "8px",
    zIndex: 999,
  });
  
export const AlertComponent = styled(Alert)({
    "& .MuiAlert-icon": {
      display: "flex",
      alignItems: "center",
    },
    "& .MuiAlert-action": {
      display: "flex",
      alignItems: "center",
    },
    width: "100%",
  });
  
export const AlertContainer = styled(Box)({
      width: "100%",
      maxHeight: "200px",
      overflow: "hidden",
  });
  